export default __webpack_public_path__ + "static/media/user-default.a6143582.png";